import ContactMe from '../components/contactme/ContactMe'

const ContactPage = () => {
    return (
        <div>
            <ContactMe />
        </div>
    );
}

export default ContactPage;